import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';

const MonitorSesion = (props) => {

    const { show, message, accept, cancel } = props;

    return (
        <Modal show={show} aria-labelledby="contained-modal-title-vcenter" centered>

            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>

            <Modal.Footer className="text-center">
                <Button variant="secondary" onClick={accept}>Extender Sesión</Button>
                <Button variant="primary" onClick={cancel}>Cerrar Sesión</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MonitorSesion;